/*
 * Copyright (c) Nexign, JSC, 2019.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @version 1.1.0
 * @since 1.1.0
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../../../../theme';
import { ChartCategoryPadding } from '../../ChartCategory/ChartCategory';

export const ChartDynamicLabelStyled = styled.div.attrs({
    'className': 'chart-dynamic__label',
    'data-name': 'chartLabelDynamic',
})`
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: space-between;
    margin-top: -15px;
    margin-left: ${ChartCategoryPadding.left}px;
    margin-right: ${ChartCategoryPadding.right}px;
    padding-top: 10px;
    background: ${colors.backgroundColorWhite};

`;

export const ChartDynamicLabelTextStyled = styled.span`
    ${fonts.textSmall};
`;
